module.exports = __webpack_public_path__ + "static/media/seriousAutoAccident.c03e75f4.mp3";